
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { CardFooter } from '@/components/ui/card';

export type SubmitButtonProps = {
  isSubmitting: boolean;
  onSubmit: () => void;
};

export const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting, onSubmit }) => {
  return (
    <CardFooter>
      <Button 
        onClick={onSubmit} 
        type="button"
        className="w-full" 
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Envoi en cours...
          </>
        ) : 'Envoyer mon feedback'}
      </Button>
    </CardFooter>
  );
};
